import React from "react";
import {IQuestion} from "../../../data/interfaces/IQuestion";
import {Utils} from "../../../data/utils";
import "./style.scss";


export function CheckBoxQuestionComponent(props: {
    question: IQuestion,
    onChange: (node: IQuestion) => void;
}) {

    const { question, onChange } = props;


    const change = () => {
        const lastOptionBitValue = Utils.shiftBit(question.options.length - 1);

        question.isValid = !(question.selectedValue === undefined || (
            question.allowCustomAnswer === true
            && (question.selectedValue & lastOptionBitValue) === lastOptionBitValue
            && (question.customAnswer === undefined || question.customAnswer.trim().length === 0)
        ));

        onChange(question);
    }


    return (
        <div className="survey-form-section">
            {
                (question.text !== undefined) && (
                    <label className="survey-form-section-label" htmlFor="name">
                        {question.text}
                    </label>
                )
            }

            <div className="survey-form-section-content">

                <div className="survey-form-checkboxes-list">
                    {
                        question.options.map((option, optionIndex) => {
                            const bitValue = Utils.shiftBit(optionIndex);
                            return (
                                <label className="survey-form-checkbox-container" key={optionIndex}>
                                    <input className="survey-form-input-checkbox-input"
                                           type="checkbox"
                                           name={question.id.toString()}
                                           onChange={(event) => {
                                               if (event.target.checked) {
                                                   question.selectedValue = question.selectedValue !== undefined ? question.selectedValue |= bitValue : bitValue;
                                               } else {
                                                   question.selectedValue = question.selectedValue !== undefined ? question.selectedValue &= ~bitValue : 0;
                                               }
                                               change();
                                           }}
                                    />
                                    <span className="survey-form-checkbox-checkmark"></span>
                                    <span>{option.optionText}</span>
                                    <div className="survey-form-checkbox-outline-effect"></div>
                                </label>
                            )
                        })
                    }
                </div>

                {
                    (question.allowCustomAnswer === true && question.selectedValue !== undefined && (question.selectedValue & Utils.shiftBit(question.options.length - 1)) === Utils.shiftBit(question.options.length - 1)) && (
                        <div className="survey-form-textarea-container">
                            <textarea
                                className="survey-form-input"
                                rows={6}
                                placeholder="Введите текст..."
                                value={question.customAnswer}
                                onChange={(event) => {
                                    question.customAnswer = event.target.value;
                                    change();
                                }}
                            />
                        </div>
                    )
                }

            </div>

        </div>
    )
}